import { Injectable } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

@Injectable({
  providedIn: 'root',
})
export class CmsPaginationService {
  maxNumberOfPageButtons = 5;
  pageNumbers: number[] = [];

  constructor() {}

  selectPageSize<T>(
    dataSource: MatTableDataSource<T>,
    selectedPageSize: string,
  ) {
    dataSource.paginator._changePageSize(+selectedPageSize);
    this.setPageToDefault(dataSource);
  }

  selectPage<T>(dataSource: MatTableDataSource<T>, index: number) {
    dataSource.paginator.pageIndex = index;
    dataSource.paginator.previousPage();
    this.populatePageButtonArray(dataSource);
  }

  previousPage<T>(dataSource: MatTableDataSource<T>) {
    dataSource.paginator.previousPage();
    this.populatePageButtonArray(dataSource);
  }

  nextPage<T>(dataSource: MatTableDataSource<T>) {
    dataSource.paginator.nextPage();
    this.populatePageButtonArray(dataSource);
  }

  isActivePage<T>(
    dataSource: MatTableDataSource<T>,
    currentIndex: number,
  ): boolean {
    return (
      dataSource.paginator &&
      dataSource.paginator.pageIndex + 1 === currentIndex
    );
  }

  populatePageButtonArray<T>(dataSource: MatTableDataSource<T>) {
    const dataLength = dataSource.filteredData.length;
    if (dataLength === 0) {
      this.pageNumbers = [];
      return;
    }

    const n = Math.ceil(dataLength / dataSource.paginator.pageSize);
    const numberOfPageButtons =
      n > this.maxNumberOfPageButtons ? this.maxNumberOfPageButtons : n;

    if (numberOfPageButtons < 5 || dataSource.paginator.pageIndex === 0) {
      this.pageNumbers = [];

      if (numberOfPageButtons === 0) {
        return;
      }

      for (let i = 1; i <= numberOfPageButtons; i++) {
        this.pageNumbers.push(i);
      }
    } else {
      const currentPageIndex = dataSource.paginator.pageIndex;

      if (currentPageIndex === 1) {
        this.pageNumbers = [1, 2, 3, 4, 5];
      }

      let start =
        currentPageIndex - 2 < 0
          ? this.pageNumbers[0]
          : currentPageIndex - 2 + 1;
      let end = currentPageIndex + 2 > n - 1 ? n : currentPageIndex + 2 + 1;

      if (end - start + 1 < numberOfPageButtons) {
        start =
          end - numberOfPageButtons >= 0
            ? end - numberOfPageButtons + 1
            : start;
      }

      if (end - start + 1 < numberOfPageButtons) {
        end += numberOfPageButtons - (end - start + 1);
      }

      this.pageNumbers = [];
      for (let i = start; i <= end; i++) {
        this.pageNumbers.push(i);
      }
    }
  }

  setPageToDefault<T>(dataSource: MatTableDataSource<T>) {
    if (dataSource.paginator) {
      dataSource.paginator.firstPage();
    }

    this.populatePageButtonArray(dataSource);
  }
}
